import { render, staticRenderFns } from "./tablaCategoria.vue?vue&type=template&id=aed9a526&scoped=true&"
import script from "./tablaCategoria.vue?vue&type=script&lang=js&"
export * from "./tablaCategoria.vue?vue&type=script&lang=js&"
import style0 from "./tablaCategoria.vue?vue&type=style&index=0&id=aed9a526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed9a526",
  null
  
)

export default component.exports